import { v4 as uuid } from "uuid";

export const generateChatSessionId = () => {
  return uuid();
};
